import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { findDeviceBySupportId, isStatus } from '../lib/api';
import { useScope } from '../scope/scope';
import { Button } from '../ui/Button';

export function FindSupportId() {
  const { mspId } = useScope();
  const navigate = useNavigate();
  const [id, setId] = useState('');
  const lookup = useMutation({ mutationFn: () => findDeviceBySupportId(mspId, id.trim()),
    onSuccess: device => navigate(`/w/${mspId}/devices/${device.id}?tab=remote`) });
  return <form className="flex flex-wrap items-center gap-2" onSubmit={e => { e.preventDefault(); lookup.mutate(); }}>
    <label htmlFor="find-support-id" className="text-sm font-medium">Find by support ID</label>
    <input id="find-support-id" inputMode="numeric" autoComplete="off" placeholder="482-917" pattern="[0-9]{3}-?[0-9]{3}"
      maxLength={7} required value={id} onChange={e => { setId(e.target.value); lookup.reset(); }}
      className="w-32 rounded-md border border-line bg-raised px-3 py-2 font-mono text-sm" />
    <Button type="submit" size="sm" disabled={lookup.isPending}>Find device</Button>
    {lookup.isError && <p role="alert" className="text-sm text-attention">{isStatus(lookup.error, 404)
      ? 'No device with that support ID is visible in this workspace.' : 'The device couldn’t be found. Check the ID and try again.'}</p>}
  </form>;
}
